export default {
  stompClient: {},
  stompHeaders: {},
  setStompClient(newStompClient) {
    this.stompClient = newStompClient
  },
  setStompHeaders(newStompHeaders) {
    this.stompHeaders = newStompHeaders
  }
}
